module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/promo/7-dd262f3f90c8384d10c5b6f0d65c616e.png";